<template>

    <Head>
        <title>Food Orders | NutriStudents K-12</title>
        <meta name="description" content="Food Orders">
    </Head>
    <default-layout>
        <BreadcrumLayout>
            <a href="#" class="link-color"><U>Planning</U></a>
        </BreadcrumLayout>
        <PageTitleLayout>
            <div class="w-full flex  justify-between md:items-center items-end">
                <h1 class="heading-color xl:text-4xl text-2xl font-bold text-left">Food Orders</h1>
                <inertia-link :href="route('order-calculator')" class="">
                    <button
                        class="button-color text-white font-bold py-3 xl:px-4 px-2 lg:ml-6 sm:ml-6 ml-6 rounded lg:mt-0 sm:mt-0 xl:mt-10 uppercase">
                        Create New Order
                    </button></inertia-link>
            </div>

        </PageTitleLayout>
        <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
            <header
                class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg h-10">
                <div class="relative md:w-56">
                </div>

                <!-- <svg class="mr-3 h-6 w-6 text-white " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                        clip-rule="evenodd" />
                </svg> -->
            </header>
        </div>

        <TableIndexLayout>
            <div class="-my-2">
                <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
                    <div class="shadow overflow-x-auto">
                        <table class="min-w-full">
                            <thead class="header-bg-color">
                                <tr>
                                    
                                    <th scope="col"
                                        class="w-1/6 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider whitespace-nowrap">
                                        Site/Group
                                    </th>
                                    <th scope="col"
                                        class="w-1/6 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider whitespace-nowrap">
                                        First Date / Last Date
                                    </th>
                                    <th scope="col"
                                        class="w-1/6 id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative whitespace-nowrap">
                                        Creation Date<i class="fa fa-sort-asc food-orders" aria-hidden="true"></i> <i
                                            class="fa fa-sort-desc food-orders" aria-hidden="true"></i>
                                    </th>
                                    <th scope="col"
                                        class="w-1/6 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider whitespace-nowrap">
                                        On Order
                                    </th>
                                    <th scope="col"
                                        class="w-1/6 px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider whitespace-nowrap">

                                    </th>

                                </tr>
                            </thead>
                            <tbody>
                                <!-- Odd row -->
                                <tr v-for="order in orders" class="bg-white">
                                    
                                    <td v-if="order.site_type == 'site'"
                                        class="w-1/6 px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ order.sitename }}
                                    </td>

                                    <td v-if="order.site_type == 'group'"
                                        class="w-1/6 px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                                        {{ order.menu_creation_group?.name }}
                                    </td>

                                    <td class="w-1/6 px-6 py-4 whitespace-nowrap text-base text-color">
                                        {{ formatDate(order.start_date) }} / {{ formatDate(order.end_date) }}

                                    </td>

                                    <td
                                        class="w-1/6 px-6 py-4 whitespace-nowrap text-base font-bold underline id-color uppercase">
                                        <inertia-link if="order.is_food_order"
                                            :href="route('foodorder-detail-edit-step3') + `?order_id=${order.id}`"
                                            class="">
                                            {{ formatDate(order.created_at) }}
                                        </inertia-link>

                                        <!-- <inertia-link v-else :href="route('order-calculator') + `?order_id=${order.id}`"
                                            class="">
                                            {{ formatDate(order.created_at) }}
                                        </inertia-link> -->
                                    </td>

                                    <td class="w-1/6 px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                                        <span v-if="order.status.toLowerCase() == 'completed' || order.status.toLowerCase() == 'complete'" class="text-green-500 capitalize">
                                            Completed
                                        </span>

                                        <span v-if="order.status.toLowerCase() == 'draft'" class="text-yellow-500 capitalize">
                                            {{ order.status }}
                                        </span>
                                    </td>

                                    <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                                        <i title="Download" @click="downloadExcel(order.id, 'orderwise')"
                                            class="fa fa-download pr-3 cursor-pointer" aria-hidden="true"></i>

                                        <inertia-link title="Edit" if="order.is_food_order"
                                            :href="route('foodorder-detail-edit-step3') + `?order_id=${order.id}`"
                                            class="">
                                            <i class="fa fa-pencil-square-o pr-3" aria-hidden="true"></i>
                                        </inertia-link>


                                        <!-- <inertia-link v-else title="Edit"
                                            :href="route('order-calculator') + `?order_id=${order.id}`" class="">
                                            <i class="fa fa-pencil-square-o pr-3" aria-hidden="true"></i>
                                        </inertia-link> -->



                                        <i title="Delete" @click="deleteOrder(order.id)"
                                            class="fa fa-trash cursor-pointer  pr-3" aria-hidden="true"></i>

                                        <i title="Share" @click="openSharePopUp(order.id)"
                                            class="fa fa-share cursor-pointer" aria-hidden="true"></i>


                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="float-left w-full flex justify-start px-10">
                <paginate :urlsArray="links"></paginate>
            </div>

            <div class="mt-12 flex justify-end pr-10 w-full mb-8">
                <inertia-link :href="route('order-calculator')" class="

                                ">
                    <button class="button-color text-white font-bold py-1.5 px-4 mb- rounded focus:outline-none uppercase">
                        Create New Order
                    </button> </inertia-link>
            </div>
        </TableIndexLayout>

        <jet-dialog-modal :show="isShare" @close="isShare = false">
            <template #title>
                <div class="flex justify-between items-center  text-xl font-bold">
                    Share Food Order Report
                </div>
            </template>

            <template #content>
                <table>
                    <thead>
                        <tr>
                            <th class="text-left px-3 py-3">Email</th>
                            <th>
                                <!-- <i class="fa fa-plus-circle plus-font-size products-edit-minus-color cursor-pointer" aria-hidden="true" @click="addEmail(i)">
                    </i> -->
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr v-for="(email, i) in shareForm.emails">
                            <td class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                                <input type="text" v-model="shareForm.emails[i]"
                                    class="2xl:text-base text-base text-gray-400 xl:mt-0 mt-4 sm:w-80 w-60 shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height input-background"
                                    placeholder="Email">

                            </td>
                            <td class="px-3 py-3 text-center text-sm font-bold text-gray-600 uppercase">
                                <i v-if="i == 0"
                                    class="fa fa-plus-circle plus-font-size products-edit-minus-color cursor-pointer"
                                    aria-hidden="true" @click="addEmail(i)">
                                </i>


                                <i v-if="i != 0 && shareForm.emails.length > 1" @click="removeEmail(i)"
                                    class="fa fa-minus-circle plus-font-size products-edit-minus-color cursor-pointer"
                                    aria-hidden="true"></i>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </template>

            <template #footer>
                <div class="flex justify-end items-center">
                    <button @click="isShare = false"
                        class="inline-flex items-center  border border-gray-300   uppercase tracking-widest shadow-sm focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-200 active:text-gray-800 active:bg-gray-50 disabled:opacity-25 transition bg-gray-500 text-white  justify-center rounded-md font-bold px-4 py-3  text-base mr-2">Cancel</button>

                    <button v-if="shareForm.emails[0] != ''" @click="shareOrder"
                        class="inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase  text-white text-base  button-color focus:outline-none">Share</button>

                </div>
            </template>
        </jet-dialog-modal>
    </default-layout>
</template>

<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import JetDialogModal from '@/Jetstream/DialogModal';

export default {

    props: ['orders1'],
    data() {
        return {
            isShare: false,
            shareForm: this.$inertia.form({
                order_id: null,
                emails: []
            }),
            orders: this.orders1.data,
        }
    },
    components: {
        DefaultLayout,
        Welcome,
        BreadcrumLayout,
        PageTitleLayout,
        TableFilterLayout,
        TableIndexLayout,
        JetDialogModal
    },
    methods: {
        addEmail() {
            this.shareForm.emails.push('');
        },
        removeEmail(index) {
            this.shareForm.emails.splice(index, 1);
        },
        shareOrder() {
            this.shareForm.post(this.route('share-order-on-mail'), {
                onSuccess: () => {
                    this.$toast.success('Order share successfully!');
                },
            });
        },
        openSharePopUp(order_id) {
            this.shareForm.order_id = order_id;
            this.shareForm.emails = [''];
            this.isShare = true;
        },
        formatDate(dateString) {
            // console.log('dateString', dateString);
            if (dateString == undefined) return '';
            const dateObject = new Date(dateString);
            const options = {
                // weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric",
            };
            return dateObject.toLocaleDateString(undefined, options);
        },
        deleteOrder(orderId) {
            console.log('order id', orderId);
            if (confirm('Are you sure you want to delete this order?')) {

                axios
                    .post("/delete-food-order", {
                        order_id: orderId,
                    })
                    .then((response) => {
                        if (response.data.status == 'success') {
                            const indexToDelete = this.orders.findIndex(order => order.id === orderId);
                            console.log(indexToDelete);
                            // If the order is found in the 'orders' array, remove it
                            if (indexToDelete !== -1) {
                                this.orders.splice(indexToDelete, 1);
                                console.log('Order deleted successfully.');
                                this.$toast.error("Food Order Delete Successfully.");

                            } else {
                                console.warn('Order not found in the data.');
                            }
                        }
                        // console.log(response.data.status);
                    })
                    .catch((error) => console.error(error));
            }
        },
        downloadExcel(id, type) {
            console.log('Id', id);
            axios
                .get("/food-order/download/excel", {
                    params: {
                        order_id: id,
                        type: type,
                    },
                    responseType: 'blob'
                })
                .then((response) => {
                    // Create a blob from the response data
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    // Generate a temporary download link
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'order_wise_report.xlsx'); // Set the desired filename
                    document.body.appendChild(link);

                    // Click the link to trigger the download
                    link.click();
                    // Clean up the temporary link
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => console.error(error));
        }
    }
};
</script>

<style>
@media screen and (min-width: 1500px) {
    .id_arrow .fa-sort-desc.food-orders:before {
        content: "\f0dd";
        position: absolute;
        top: 17px;
        left: 1px;
        padding-left: 7px;
        color: #219FD5;
    }

    .id_arrow .fa-sort-asc.food-orders:before {
        content: "\f0de";
        color: #219FD5;
        padding-left: 7px;
        position: absolute;
        top: 15px;
        left: 1px;
    }
}

@media screen and (max-width: 1499px) {
    .id_arrow .fa-sort-asc.food-orders:before {
        content: "\f0de";
        color: #219FD5;
        padding-left: 7px;
        position: absolute;
        top: 16px;
        left: 1px;
    }

    .id_arrow .fa-sort-desc.food-orders:before {
        content: "\f0dd";
        position: absolute;
        top: 17px;
        left: 1px;
        padding-left: 7px;
        color: #219FD5;
    }

}
</style>
